import { useMutation } from '@tanstack/react-query';
import { signOutService } from '../services';

export const useSignOut = () => useMutation({ mutationFn: signOutService });
